import {FormLoaderError} from '@bff/loader-utils';

type Dataset = DOMStringMap & Record<string, string | undefined>;

const toDataAttribute = (attributeName: string) =>
    `data-${attributeName.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`)}`;

export function parseRequiredString(dataset: Dataset, attributeName: string): string {
    const value = dataset[attributeName];

    if (!value) {
        throw new FormLoaderError(`Missing required attribute: ${toDataAttribute(attributeName)}`, 404);
    }

    return value;
}

export function parseBoolean(
    dataset: Dataset,
    attributeName: string
): boolean | undefined {
    const value = dataset[attributeName];

    if (value === 'true') {
        return true;
    }

    return false;
}

export function parseOptionalEnum<T extends string>(
    dataset: Dataset,
    attributeName: string,
    allowedValues: readonly T[]
): T | undefined {
    const value = dataset[attributeName];

    if (value === undefined) {
        return undefined;
    }

    if ((allowedValues as readonly string[]).includes(value)) {
        return value as T;
    }

    throw new FormLoaderError(`Invalid value "${value}" provided for ${toDataAttribute(attributeName)}}`, 404);
}

